<template>
  <v-app
    style="position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;"
    class="fixNotchMarginTop"
  >
    <div class="text-center" style="z-index:100002">


      <v-snackbar style="z-index:100002" multi-line
      v-model="showPushPermission" :top="true" class="fixNotchMarginTop"
      :timeout="200000" color="white"
    >
      <v-row> 
        <v-col cols ="12" class="pa-0 px-2"> 
              <v-icon style="position: absolute;" x-large color="#0099CC">mdi-bullhorn</v-icon>
              <div style="margin-left:55px"> 
                <span class="d-inline-block" 
                style="width: 100%;color:black;"> {{ $t('WEB_PUSH_POPUP_MSG1')}} </span> 
                <span class="d-inline-block" 
                style="width: 100%;color:black;"> {{ $t('WEB_PUSH_POPUP_MSG2')}} </span> 
              </div>
          </v-col>   
          <v-col cols ="12" class="py-0 pr-6">
              
              <v-btn  color="black" style="float: right;" text  @click="showPushPermission = false" >{{$t('WEB_PUSH_POPUP_NOT_NOW')}}</v-btn> 
              <v-btn  text style="color: #0099CC;  float: right;"  @click="requestPushPermission" >{{$t('WEB_PUSH_POPUP_ACTIVATE')}}</v-btn> 
          </v-col> 
              
      </v-row>
    </v-snackbar>

 

      <v-snackbar
        style="z-index:100002"
        v-model="snackbar"
        :top="true"
        class="fixNotchMarginTop"
        :timeout="timeout"
        color="success"
      >
        {{ text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">{{$t('TOAST_POPUP_CLOSE')}}</v-btn>
        </template>
      </v-snackbar>


      <v-snackbar style="z-index:100002" multi-line
      v-model="showPush" :top="true" class="fixNotchMarginTop"
      :timeout="20000" color="white"
    >
      <v-row> 
        <v-col cols ="12" class="pa-0 px-2">
              <v-img :src="push.image" max-width="75" style="position: absolute;"/>
              <div style="margin-left:85px"> 
                <span class="black--text bold d-inline-block" style="width: 100%;"> {{ push.title }} </span>
                <span class="black--text d-inline-block"> {{ push.message }} </span>
              </div>
          </v-col>   
          <v-col cols ="12" class="py-0 pr-6">
              
              <v-btn  color="black" style="float: right;" text  @click="showPush = false" >{{$t('PUSH_POPUP_CLOSE')}}</v-btn> 
              <v-btn  text style="color: #0099CC;  float: right;"  @click="showRundownAnnouncements(push.rundownId)" >{{$t('PUSH_POPUP_VIEW')}}</v-btn> 
          </v-col> 
              
      </v-row>
    </v-snackbar>
    </div>


    <v-row>
     <v-col cols="12" md="6" class="mx-auto">
            <v-alert
              v-model="pushNotSupported"
              dense style="z-index:100002; position:fixed; bottom:20px;" 
              border="left" dismissible
              type="warning"
            >
              {{ pushNotSupportedText }}
            </v-alert>
    </v-col>  
    </v-row>

    <WelcomeDialog ref="welcomeDialog" />
    <RundownPictureDialog ref="rundownPictureDialog" />
    <AnnouncementDialog ref="announcementDialog" v-on:newAnnouncement="newAnnouncement($event)" />
    <RundownHistoryDialog ref="historyDialog" />
    <NewAnnouncementDialog ref="newAnouncementDialog" />
    <ProfileDialog ref="profileDialog"></ProfileDialog>
    <NewFeaturesDialog ref="newFeaturesDialog"></NewFeaturesDialog>
    <ShareRundownDialog ref="shareRundownDialog"></ShareRundownDialog>
    <SettingsDialog ref="settingsDialog"></SettingsDialog>
  </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
//import styles from './assets/App.css'
import WelcomeDialog from "./components/WelcomeDialog";
import RundownPictureDialog from "./components/RundownPictureDialog";
import AnnouncementDialog from "./components/AnnouncementDialog";
import NewAnnouncementDialog from "./components/NewAnnouncementDialog";
import ProfileDialog from "./components/profile/ProfileDialog";
import NewFeaturesDialog from "./components/newfeatures/NewFeaturesDialog";
import ShareRundownDialog from "./components/sharerundown/ShareRundownDialog"; 
import SettingsDialog from "./components/SettingsDialog"; 
import RundownHistoryDialog from "./components/RundownHistoryDialog"; 

export default {
  name: "App",

  components: {
    WelcomeDialog,
    RundownPictureDialog,
    AnnouncementDialog,
    NewAnnouncementDialog,
    ProfileDialog,
    NewFeaturesDialog,
    ShareRundownDialog,
    SettingsDialog,
    RundownHistoryDialog,
  },
  methods: {
    newAnnouncement: function (payload) {
      this.handleTheme();
      this.$refs["newAnouncementDialog"].createAnnouncement(
        payload.user,
        payload.rundown
      );
    },
    showToast: function (text) {
      this.handleTheme();
      this.text = text;
      this.snackbar = true;
    },
    handleProfileDialog: function (rundownApp) {
      this.handleTheme();
      this.$refs["profileDialog"].handleProfile(rundownApp);
    },
    handleWelcomeDialog: function () {
      this.handleTheme();
      this.$refs["welcomeDialog"].handleWelcome((welcomeShown)=> {
          this.handleNewFeaturesDialog(welcomeShown);
      });
    },
    handleNewFeaturesDialog: function (welcomeShown) {
      this.$refs["newFeaturesDialog"].handleNewFeatures(welcomeShown);
    },
    handleShareRundownDialog: function (rundownId, accessToken) {
      this.$refs["shareRundownDialog"].handleShareRundown(
        rundownId,
        accessToken
      );
    },
    showRundownPictureDialog: function (rundown, callback) {
      this.handleTheme();
      this.$refs["rundownPictureDialog"].showDialog(rundown, callback);
    },
    showRundownAnnouncements: function (rundownId) {
      this.handleTheme();
      this.showPush = false;
      this.$refs["announcementDialog"].showRundownAnnouncements(rundownId);
    },
    showAnnouncements: function (user, rundown) {
      this.handleTheme();
      this.$refs["announcementDialog"].showAnnouncements(user, rundown);
    },
    showHistory: function (user, rundown) {
      this.handleTheme();
      this.$refs["historyDialog"].showHistory(user, rundown);
    },
    showSettings: function (user) {
      this.handleTheme();
      this.$refs["settingsDialog"].showSettings(user);
    },
    handleTheme() {
      var prop = window.rundownApp.prefs.styleMode;
      this.$vuetify.theme.dark = prop === "on";
    },
    showPremiumMode() {
      //Method to hide or show all links to go to suscribe.
      return (window.rundownApp.isCordova===false || window.rundownApp.device.nativeVersion>='2.0');
    },
    appUpdateRequired() {
      return window.rundownApp.isCordova===true && window.rundownApp.device && window.rundownApp.device.nativeVersion<'2.0';
    },
    onPurchaseCompleted(product){
        this.$refs["profileDialog"].onPurchaseCompleted(product);
    },
    requestPushPermission: function() {
      this.showPushPermission=false;
        window.push_requestPermission();
    },
    checkPushSupport: function() {

    if (!window.rundownApp || !window.rundownApp.localStorage) {
            setTimeout(this.checkPushSupport, 2000);
            return;
          }

        if (window.rundownApp.isCordova===true) return;

        if (window.push_isSupported()==false)
        {
          this.pushNotSupported=true;
          this.pushNotSupportedText=this.$t('WEB_PUSH_NOT_SUPPORTED_MSG');
          let me = this;
          setTimeout( function() {
              me.pushNotSupported=false;
          },5000);
          return;
        }

        if (window.push_getPermission()=='default')
        {
            this.showPushPermission=true;
            let me = this;
            setTimeout( function() {
                me.showPushPermission=false;
            },5000);
            return;
        }
        else
          if (window.push_getPermission()=='granted')
          {
              window.push_init();
          }
        else
        {
          this.pushNotSupported=true;
          this.pushNotSupportedText=this.$t('WEB_PUSH_DISABLED_MSG');
          let me = this;
          setTimeout( function() {
              me.pushNotSupported=false;
          },5000);
          return;
        }
      
    },
    onPushReceived: function (push) {
      window.serverlogMessage('onPushReceived-'+window.rundownApp.device.platform,JSON.stringify(push));
      //cordova android : {"count":"3","image":"https://storage.g.....jpg","title":"IHF July 2020 II",
      //   "message":"a38","additionalData":{"content-available":"1","image-type":"circle","payload":"300","type":"sync",
      //   "notId":"673100853","coldstart":false,"foreground":true}}

      // cordova ios : {"message":"p9","title":"8/23 Service","count":2,
      //     "additionalData":{"google.c.a.e":"1","coldstart":false,"count":"2","image":"https://rundownjpg",
      //       "payload":"{ \"rundownId\": 471} ","notId":"1428881999","type":"sync",
      //       "gcm.message_id":"1599042470627528","mutable-content":1,"foreground":true}}

      if (push.additionalData) {
        //cordova
        this.push.title = push.title;
        this.push.message = push.message;
        this.push.image = push.image ? push.image : push.additionalData.image; //android / iOS
        this.push.rundownId = push.additionalData.payload.rundownId ? push.additionalData.payload.rundownId : //android
                              JSON.parse(push.additionalData.payload).rundownId;  // ios
      } else {
        //web
        this.push.title = push.data.title;
        this.push.message = push.data.body;
        this.push.image = push.data.image;
        this.push.rundownId = JSON.parse(push.data.payload).rundownId;
      }
      
       this.showPush = true;

       window.rundownApp.fileManager.getInstance().ListFiles(true);
    },
  },
  data: () => ({
    snackbar: false,
    showPush: false,
    text: null, 
    pushNotSupported: false,
    showPushPermission: false, 
    pushNotSupportedText: null,
    timeout: 2000,
    push: {
      title: null,
      message: null,
      image: null,
      rundownId: null,
    },
  }),
  created: function () {
    window.vueapp = this; 
    setTimeout(this.handleWelcomeDialog, 2000);
    setTimeout(this.checkPushSupport, 2000);
    
  },
};
</script>
 